module.exports = function(aiModule) {
	'use strict'
	aiModule.directive('aiAllConfigurationsDir',aiAllConfigurationsDir);
	aiAllConfigurationsDir.$inject=[];
	function aiAllConfigurationsDir() {
		return {
			template: require('./partial/aiAllConfigurations.html'),
			controller:'aiAllConfigurationsController',
			controllerAs:'vmaac',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/aiModule/all-configurations/js/directive/aiAllConfigurationsDirective.js
// module id = 487
// module chunks = 0